import $ from 'jquery';
import Color from "@arcgis/core/Color.js";
import config from "@arcgis/core/config.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import Map from "@arcgis/core/Map.js";
import MapView from "@arcgis/core/views/MapView.js";

import { geocode } from "@esri/arcgis-rest-geocoding";
import {ApiKeyManager} from "@esri/arcgis-rest-request";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import Graphic from "@arcgis/core/Graphic.js";
import Point from "@arcgis/core/geometry/Point.js";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol.js";
import type FeatureSet from "@arcgis/core/rest/support/FeatureSet.js";
import type FeatureLayerView from "@arcgis/core/views/layers/FeatureLayerView.js";

const API_KEY = "AAPKe6d3defcf4504dc2a2e97382a07eaa25xypC_dZasyXWAcMbo6VwLjGRJUOLV_l_DQyismJfFxawtzsW8syEruqqFK1ZsD_I";
const YOUR_LOCATION_POINT_SYMBOL = new SimpleMarkerSymbol({
	color: [202, 155, 87],
	outline: {
		color: [255, 255, 255],
		width: 2
	}
});

$(() => {
	if (document.getElementById("viewDiv")) {
		config.apiKey = API_KEY;
		const map = new Map({
			basemap: "arcgis/topographic" // Basemap layer service
		});
		const featureLayer = new FeatureLayer({url: "https://services.arcgis.com/m7XfTm3SBjnY2g9T/arcgis/rest/services/Basemap/FeatureServer/0"});
		featureLayer.load().then(() => {
			const view = new MapView({
				map: map,
				extent: featureLayer.fullExtent,
				container: "viewDiv" // Div element
			});
			view.whenLayerView(featureLayer).then((layerView: FeatureLayerView) => {
				layerView.highlightOptions = {
					color: new Color("#1079c4"),
					haloOpacity: 0,
					fillOpacity: 0.2
				};
				featureLayer.queryFeatures().then((r: FeatureLayer) => layerView.highlight(r.features));
			});
			view.zoom = view.zoom - 1;
			map.add(featureLayer);
		});
		let activeLocationGraphic: Graphic|undefined = undefined;
		const graphicsLayer = new GraphicsLayer();
		map.add(graphicsLayer);

		(document.getElementById("addressSearch") as HTMLFormElement).addEventListener('submit', e => {
			e.preventDefault();

			geocode({
				singleLine: (document.getElementById("arcgisInput") as HTMLInputElement).value,
				authentication: ApiKeyManager.fromKey(API_KEY)
			}).then(r => {
				r.candidates.forEach(c => {
					if (activeLocationGraphic) {
						graphicsLayer.remove(activeLocationGraphic);
						activeLocationGraphic = undefined;
					}

					const geometry = new Point(c.location);
					featureLayer.queryFeatures({geometry}).then((r: FeatureSet) => {
						const addressSearchResults = document.getElementById("addressSearchResults");
						const boldSpan = addressSearchResults.querySelector<HTMLElement>(".bold");
						const normalSpan = addressSearchResults.querySelector<HTMLSpanElement>(".normal");
						if (r.features.length) { // According to the ArcGIS docs, this mess SOMEHOW will only return features if the searched point is within them.
							boldSpan.textContent = "Yes,";
							normalSpan.textContent = " your address is within the Rice Creek Watershed District.";
						} else {
							boldSpan.textContent = "No,";
							normalSpan.textContent = " your address is not within the Rice Creek Watershed District.";
						}
						addressSearchResults.style.display = '';
						addressSearchResults.setAttribute("data-address-is-in-district", r.features.length ? "true" : "false");
					})
					activeLocationGraphic = new Graphic({geometry, symbol: YOUR_LOCATION_POINT_SYMBOL});
					graphicsLayer.add(activeLocationGraphic);
				});
			});
		});
	}
});
